import { css } from "@emotion/react";
import tw from "twin.macro";

import { FONT_BASE_URL } from "app/constants/variables";

const GlobalStyles = css`
  @font-face {
    font-family: "Roobert";
    src: url("${FONT_BASE_URL}/Roobert-Light.otf");
    font-weight: 300;
  }

  @font-face {
    font-family: "Roobert";
    src: url("${FONT_BASE_URL}/Roobert-Regular.otf");
    font-weight: normal;
  }

  @font-face {
    font-family: "Roobert";
    src: url("${FONT_BASE_URL}/Roobert-Medium.otf");
    font-weight: 500;
  }

  @font-face {
    font-family: "Roobert";
    src: url("${FONT_BASE_URL}/Roobert-SemiBold.otf");
    font-weight: 600;
  }

  @font-face {
    font-family: "Roobert";
    src: url("${FONT_BASE_URL}/Roobert-Bold.otf");
    font-weight: bold;
  }

  @font-face {
    font-family: "Roobert";
    src: url("${FONT_BASE_URL}/Roobert-Heavy.otf");
    font-weight: 900;
  }

  * {
    margin: 0;
    padding: 0px;
    box-sizing: border-box;
  }

  html {
    font-size: 10px;
  }

  html,
  body,
  button {
    margin: 0;
    font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI",
      "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
      "Helvetica Neue", sans-serif;
  }

  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 1rem;

    ${tw`text-text-high`};
  }

  button,
  a {
    cursor: pointer;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
      monospace;
  }


  input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0px 1000px var(--genesis-color-input-surface) inset !important;
  box-shadow: 0 0 0px 1000px var(--genesis-color-input-surface) inset !important;
  -webkit-text-fill-color: var(--genesis-color-text-high) !important;
  transition: background-color 5000s ease-in-out 0s !important;
  -webkit-background-clip: text !important;
  background-clip: text !important;
  color: var(--genesis-color-text-high) !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  line-height: 20px !important;
}

.grecaptcha-badge {
    visibility: hidden;
}

`;

export default GlobalStyles;
